import React, { Component, useState } from "react";

import { Row, Col, Divider, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import { API_URL } from "../../../constants";
import useAxios from "@use-hooks/axios";

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/Responsibility/Responsibility.css";

// JS Files
import ResponsibilityCard from "./ResponsibilityCard.js";

const ResponsibilityMain = (props) => {
  const [responsibilities, setResposibilities] = useState([]);

  const getResponsibility = useAxios({
    url: `${API_URL}/Social_Responsibility_Service/`,
    trigger: [],
    customHandler: (err, res) => {
      if (res) {
        console.log("data", res.data);

        setResposibilities(res.data);
      }
    },
  });

  return props.size === "laptopdesktop" ? (
    <div className="ResponsibilityBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong>مسئولیت های اجتماعی ایرانیان پوشش</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescription" style={{ color: "#fff" }}>
              شرح مسئولیت ها و فعالیت های اجتماعی ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "200px" }}>
        <Col span={5}></Col>
        <Col span={14}>
          <div
            style={{
              opacity: "95%",
              backgroundColor: "#f9f9f9",
              borderRadius: "20px",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              padding: "25px",
            }}
          >
            <p className="textParagraph">
              هلدینگ ایرانیان پوشش با اعتقاد قلبی و عزمی جزم ، «مسئولیت‌های
              اجتماعی» را به عنوان اصول حرفه ای خودر در کسب و کار همواره و همیشه
              مدنظر قرار داده و مجموعه ای از برنامه ها، استراتژی‌ها و سیاست‌های
              کلان هلدینگ در بخش های مختلف شامل : شرکت های بیمه ای، بیمه گذران و
              بیمه شدگان و خانواده های محترم شان، سهام‌داران، همکاران، مردم عزیز
              و گرانمایه ایران و ... در چارچوب این نگاه مسئولانه تنظیم و افزون
              بر این به‌صورت پیوسته اقدامات و فعالیت‌های گوناگون و گسترده‌ای را
              در بخش‌های مختلف علمی، فرهنگی، آموزشی و کمک های انسان‌دوستانه و
              خیرخواهانه با هدف مشارکت سازنده در توسعه فرهنگی و اجتماعی به انجام
              می‌رساند.
              <br />
              از این رو، ایجاد و نهادینه‌سازی فرهنگ خدمت صادقانه به عموم
              ایرانیان و پوشش گسترده خدمت رسانی در همه اقصی نقاط ایران عزیز در
              همه سطوح و ارکان هلدینگ، ارائه خدمت 24 ساعته در سرتاسر کشور، تدارک
              زیرساخت های مناسب و متنوع برای ارتباط سریع با مشتریان و کارفرمایان
              محترم و ارجمند، ارائه خدمات بیمه ای حرفه ای به مشتریان با نهایت
              احترام و تکریم، ایفای نقش موثر در حرکت اصولی و هدایت صنعت بیمه در
              جهت توسعه اینشورتک ، پرچم‌داری در بسیاری از حوزه‌های تخصصی ارزیابی
              خسارات بیمه ای و آموزش و تربیت نیروی انسانی حرفه ای و صادق در صنعت
              بیمه و کمک به انجام ارزیابی های طرح‌های بزرگ و ملی، تنها برخی از
              جلوه‌های این رویکرد جامع، صادقانه و حرفه ای است. هلدینگ ایراینان
              پوشش اعتقاد و ایمان راسخ و قلبی دارد، بنگاه اقتصادی و سازمانی که
              پایبند به ارزش ها و مسئولیت‌های اجتماعی خود باشد، لاجرم آنچه درست
              است را انجام می‌دهد، از تصمیم‌گیری‌های خودسرانه و نا‌ثواب برای
              جامعه گریزان است و با بهره‌مندی از خلاقیت و نوآوری و طرد روش‌های
              منسوخ، نوید‌بخش پیشرفت و تعالی خود و جامعه خواهد بود.
              <br />
              در همین راستا دومین جایزه csr مخفف (Corporate Social
              Responsibility) مسئولیت اجتماعی بنگاه های اقتصادی در مرکز همایش
              های صداوسیما در سال 1397 به شرکت ایرانیان پوشش اهدا گردید .
              <br />
              <Center>
                <strong style={{ color: "#4983C4", marginTop: "10px" }}>
                  خدای بزرگ , ما را در پیشبرد این هدف یاری و راهنمایی فرماید.
                </strong>
              </Center>
            </p>
          </div>
          <Center>
            <div style={{ marginTop: "-25px", zIndex: 1 }} class="circleDot">
              <Center>
                <DownOutlined
                  style={{ paddingTop: "16px", color: "#ed1c24" }}
                />
              </Center>
            </div>
          </Center>
        </Col>
        <Col span={5}></Col>
      </Row>
      <Center>
        <Margin top={5}>
          <div>
            <p className="subTitle">
              <strong>فعالیت ها</strong>
            </p>
          </div>
        </Margin>
      </Center>
      <Center>
        <div className="subTitleHR"></div>
      </Center>
      <Margin top={3}></Margin>
      <div style={{ backgroundColor: "#f6f6f6" }}>
        <Row style={{ direction: "rtl" }}>
          <Col span={3}></Col>
          <Col span={18}>
            <Margin top={4}></Margin>
            <Row>
              {getResponsibility.response?.data &&
                responsibilities.map((item, index) => {
                  return [
                    <Col
                      span={6}
                      key={index}
                      onClick={() =>
                        props.history.push(`/responsibilityinside/${item.id}`)
                      }
                    >
                      <ResponsibilityCard
                        title={item.image_title}
                        sentence={item.title}
                        image={item.image}
                        id={item.id}
                        history={props.history}
                        size="laptopdesktop"
                      />
                    </Col>,
                  ];
                })}
            </Row>
            <Margin bottom={4}></Margin>
          </Col>
          <Col span={3}></Col>
        </Row>
      </div>
    </div>
  ) : props.size === "tablet" ? (
    <div className="ResponsibilityBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft">
            <strong>مسئولیت های اجتماعی ایرانیان پوشش</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionTablet" style={{ color: "#fff" }}>
              شرح مسئولیت ها و فعالیت های اجتماعی ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <Col span={2}></Col>
        <Col span={20}>
          <div
            style={{
              opacity: "95%",
              backgroundColor: "#f9f9f9",
              borderRadius: "20px",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              padding: "25px",
            }}
          >
            <p className="textParagraphTablet">
              هلدینگ ایرانیان پوشش با اعتقاد قلبی و عزمی جزم ، «مسئولیت‌های
              اجتماعی» را به عنوان اصول حرفه ای خودر در کسب و کار همواره و همیشه
              مدنظر قرار داده و مجموعه ای از برنامه ها، استراتژی‌ها و سیاست‌های
              کلان هلدینگ در بخش های مختلف شامل : شرکت های بیمه ای، بیمه گذران و
              بیمه شدگان و خانواده های محترم شان، سهام‌داران، همکاران، مردم عزیز
              و گرانمایه ایران و ... در چارچوب این نگاه مسئولانه تنظیم و افزون
              بر این به‌صورت پیوسته اقدامات و فعالیت‌های گوناگون و گسترده‌ای را
              در بخش‌های مختلف علمی، فرهنگی، آموزشی و کمک های انسان‌دوستانه و
              خیرخواهانه با هدف مشارکت سازنده در توسعه فرهنگی و اجتماعی به انجام
              می‌رساند.
              <br />
              از این رو، ایجاد و نهادینه‌سازی فرهنگ خدمت صادقانه به عموم
              ایرانیان و پوشش گسترده خدمت رسانی در همه اقصی نقاط ایران عزیز در
              همه سطوح و ارکان هلدینگ، ارائه خدمت 24 ساعته در سرتاسر کشور، تدارک
              زیرساخت های مناسب و متنوع برای ارتباط سریع با مشتریان و کارفرمایان
              محترم و ارجمند، ارائه خدمات بیمه ای حرفه ای به مشتریان با نهایت
              احترام و تکریم، ایفای نقش موثر در حرکت اصولی و هدایت صنعت بیمه در
              جهت توسعه اینشورتک ، پرچم‌داری در بسیاری از حوزه‌های تخصصی ارزیابی
              خسارات بیمه ای و آموزش و تربیت نیروی انسانی حرفه ای و صادق در صنعت
              بیمه و کمک به انجام ارزیابی های طرح‌های بزرگ و ملی، تنها برخی از
              جلوه‌های این رویکرد جامع، صادقانه و حرفه ای است. هلدینگ ایراینان
              پوشش اعتقاد و ایمان راسخ و قلبی دارد، بنگاه اقتصادی و سازمانی که
              پایبند به ارزش ها و مسئولیت‌های اجتماعی خود باشد، لاجرم آنچه درست
              است را انجام می‌دهد، از تصمیم‌گیری‌های خودسرانه و نا‌ثواب برای
              جامعه گریزان است و با بهره‌مندی از خلاقیت و نوآوری و طرد روش‌های
              منسوخ، نوید‌بخش پیشرفت و تعالی خود و جامعه خواهد بود.
              <br />
              در همین راستا دومین جایزه csr مخفف (Corporate Social
              Responsibility) مسئولیت اجتماعی بنگاه های اقتصادی در مرکز همایش
              های صداوسیما در سال 1397 به شرکت ایرانیان پوشش اهدا گردید .
              <br />
              <Center>
                <strong style={{ color: "#4983C4", marginTop: "10px" }}>
                  خدای بزرگ , ما را در پیشبرد این هدف یاری و راهنمایی فرماید.
                </strong>
              </Center>
            </p>
          </div>
          <Center>
            <div style={{ marginTop: "-25px", zIndex: 1 }} class="circleDot">
              <Center>
                <DownOutlined
                  style={{ paddingTop: "16px", color: "#ed1c24" }}
                />
              </Center>
            </div>
          </Center>
        </Col>
        <Col span={2}></Col>
      </Row>
      <Center>
        <Margin top={4}>
          <div>
            <p className="subTitleTablet">
              <strong>فعالیت ها</strong>
            </p>
          </div>
        </Margin>
      </Center>
      <Center>
        <hr className="subTitleHRTablet" />
      </Center>
      <Margin top={3}></Margin>
      <div style={{ backgroundColor: "#f6f6f6" }}>
        <Row>
          <Col span={2}></Col>
          <Col span={20}>
            <Margin top={4}></Margin>
            <Row>
              {getResponsibility.response?.data &&
                responsibilities.map((item, index) => {
                  return [
                    <Col
                      span={12}
                      key={index}
                      onClick={() =>
                        props.history.push(`/responsibilityinside/${item.id}`)
                      }
                    >
                      <ResponsibilityCard
                        title={item.image_title}
                        sentence={item.title}
                        image={item.image}
                        id={item.id}
                        history={props.history}
                        size="tablet"
                      />
                    </Col>,
                  ];
                })}
            </Row>
            <Margin bottom={4}></Margin>
          </Col>
          <Col span={2}></Col>
        </Row>
      </div>
    </div>
  ) : (
    <div className="ResponsibilityBackground">
      <div style={{ paddingTop: "50px" }}>
        <Center>
          <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile">
            <strong>مسئولیت های اجتماعی ایرانیان پوشش</strong>
          </p>
        </Center>
        <Center>
          <Margin top={3}>
            <p className="mainTitleDescriptionMobile" style={{ color: "#fff" }}>
              شرح مسئولیت ها و فعالیت های اجتماعی ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "25px" }}>
        <Col span={1}></Col>
        <Col span={22}>
          <div
            style={{
              opacity: "95%",
              backgroundColor: "#f9f9f9",
              borderRadius: "20px",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              padding: "25px",
            }}
          >
            <p className="textParagraphMobile">
              هلدینگ ایرانیان پوشش با اعتقاد قلبی و عزمی جزم ، «مسئولیت‌های
              اجتماعی» را به عنوان اصول حرفه ای خودر در کسب و کار همواره و همیشه
              مدنظر قرار داده و مجموعه ای از برنامه ها، استراتژی‌ها و سیاست‌های
              کلان هلدینگ در بخش های مختلف شامل : شرکت های بیمه ای، بیمه گذران و
              بیمه شدگان و خانواده های محترم شان، سهام‌داران، همکاران، مردم عزیز
              و گرانمایه ایران و ... در چارچوب این نگاه مسئولانه تنظیم و افزون
              بر این به‌صورت پیوسته اقدامات و فعالیت‌های گوناگون و گسترده‌ای را
              در بخش‌های مختلف علمی، فرهنگی، آموزشی و کمک های انسان‌دوستانه و
              خیرخواهانه با هدف مشارکت سازنده در توسعه فرهنگی و اجتماعی به انجام
              می‌رساند.
              <br />
              از این رو، ایجاد و نهادینه‌سازی فرهنگ خدمت صادقانه به عموم
              ایرانیان و پوشش گسترده خدمت رسانی در همه اقصی نقاط ایران عزیز در
              همه سطوح و ارکان هلدینگ، ارائه خدمت 24 ساعته در سرتاسر کشور، تدارک
              زیرساخت های مناسب و متنوع برای ارتباط سریع با مشتریان و کارفرمایان
              محترم و ارجمند، ارائه خدمات بیمه ای حرفه ای به مشتریان با نهایت
              احترام و تکریم، ایفای نقش موثر در حرکت اصولی و هدایت صنعت بیمه در
              جهت توسعه اینشورتک ، پرچم‌داری در بسیاری از حوزه‌های تخصصی ارزیابی
              خسارات بیمه ای و آموزش و تربیت نیروی انسانی حرفه ای و صادق در صنعت
              بیمه و کمک به انجام ارزیابی های طرح‌های بزرگ و ملی، تنها برخی از
              جلوه‌های این رویکرد جامع، صادقانه و حرفه ای است. هلدینگ ایراینان
              پوشش اعتقاد و ایمان راسخ و قلبی دارد، بنگاه اقتصادی و سازمانی که
              پایبند به ارزش ها و مسئولیت‌های اجتماعی خود باشد، لاجرم آنچه درست
              است را انجام می‌دهد، از تصمیم‌گیری‌های خودسرانه و نا‌ثواب برای
              جامعه گریزان است و با بهره‌مندی از خلاقیت و نوآوری و طرد روش‌های
              منسوخ، نوید‌بخش پیشرفت و تعالی خود و جامعه خواهد بود.
              <br />
              در همین راستا دومین جایزه csr مخفف (Corporate Social
              Responsibility) مسئولیت اجتماعی بنگاه های اقتصادی در مرکز همایش
              های صداوسیما در سال 1397 به شرکت ایرانیان پوشش اهدا گردید .
              <br />
              <Center>
                <strong style={{ color: "#4983C4", marginTop: "5px" }}>
                  خدای بزرگ , ما را در پیشبرد این هدف یاری و راهنمایی فرماید.
                </strong>
              </Center>
            </p>
          </div>
          <Center>
            <div style={{ marginTop: "-25px", zIndex: 1 }} class="circleDot">
              <Center>
                <DownOutlined
                  style={{ paddingTop: "16px", color: "#ed1c24" }}
                />
              </Center>
            </div>
          </Center>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Center>
        <Margin top={4}>
          <div>
            <p className="subTitleMobile">
              <strong>فعالیت ها</strong>
            </p>
          </div>
        </Margin>
      </Center>
      <Center>
        <div className="subTitleHRMobile"></div>
      </Center>
      <Margin top={3}></Margin>
      <div style={{ backgroundColor: "#f6f6f6" }}>
        <Row>
          <Col span={3}></Col>
          <Col span={18}>
            <Row>
              {getResponsibility.response?.data &&
                responsibilities.map((item, index) => {
                  return [
                    <Col
                      span={24}
                      key={index}
                      onClick={() =>
                        props.history.push(`/responsibilityinside/${item.id}`)
                      }
                    >
                      <ResponsibilityCard
                        title={item.image_title}
                        sentence={item.title}
                        image={item.image}
                        id={item.id}
                        history={props.history}
                      />
                    </Col>,
                  ];
                })}
            </Row>
            <Margin bottom={4}></Margin>
          </Col>

          <Col span={3}></Col>
        </Row>
      </div>
    </div>
  );
};

export default ResponsibilityMain;
